import * as React from 'react';

import { Query } from 'react-apollo';
import gql from 'graphql-tag';

import { Grid } from "@material-ui/core";
import { CardBarChartMarketAndGroupAndBookstore } from '../../../shared/layout/components/CardBarChartMarketAndGroupAndBookstore';

const PUBLISHER_CATEGORY_PN_SHARE = gql`
query publisherCategoryPnShare($customFilter:  PublisherCustomFilter) {
    publisherCategoryPnShare(publisherCustomFilter: $customFilter) {
        id,
        desc,
        
        groupSalesVolume,
        marketSalesVolume,
        storeSalesVolume,

        groupSalesBilling,
        marketSalesBilling,
        storeSalesBilling
    }
}
`;

// tslint:disable-next-line:no-empty-interface
interface IPublisherCategoryPnShareProps {
    filter: any;
}

// tslint:disable-next-line:no-empty-interface
interface IPublisherCategoryPnShareState {
}

export class PublisherCategoryPnShare extends React.Component<IPublisherCategoryPnShareProps, IPublisherCategoryPnShareState> {

    public render() {
        return  (
            <Query query={PUBLISHER_CATEGORY_PN_SHARE} variables={this.props.filter}>
                {({ loading, error, data, client }) => {
                    return(
                        <Grid container={true} spacing={16}>
                            <Grid item={true} xs={6} md={6}>
                                <CardBarChartMarketAndGroupAndBookstore 
                                    data={data.publisherCategoryPnShare}
                                    loading={loading}
                                    title={'Vendas por Categoria - 30 Dias'}
                                    type={'VOLUME'}
                                />
                            </Grid>

                            <Grid item={true} xs={6} md={6}>
                                <CardBarChartMarketAndGroupAndBookstore 
                                    data={data.publisherCategoryPnShare}
                                    loading={loading}
                                    title={'Vendas por Categoria - 30 Dias'}
                                    type={'FATURAMENTO'}
                                />
                            </Grid>
                        </Grid>
                    );
                }}
            </Query>
        )
    }
}


// WEBPACK FOOTER //
// ./src/component/publisher/sale/category-pn-share/PublisherCategoryPnShare.tsx